import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export interface Port {
  id: number;
  name: string;
  code?: string | null;
  countryId?: number | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  country?: {
    id: number;
    name: string;
  } | null;
}

export const usePorts = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions | null,
) => {
  const q = options ? buildListQuery(searchParams, page, limit, options) : null;
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<Port> | Port[]>(
    q ? `${moduleConfig.module.api.list}${q}` : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  const normalized = normalizePaginatedListResponse<Port>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePort = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Port>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
